import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentSKUConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentSKUConfig;
